import React from 'react';

interface TestimonialCardProps {
    image: string;
    name: string;
    location: string;
    testimonial: string;
    rating?: number;
    avatarColor?: string;
}

const StarIcon: React.FC = () => (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="#d89d37" aria-hidden="true">
        <path d="M10 1l2.39 4.84 5.34.78-3.87 3.77.91 5.33L10 13.27l-4.77 2.45.91-5.33L2.27 6.62l5.34-.78z" />
    </svg>
);

const TestimonialCard: React.FC<TestimonialCardProps> = (props) => {
    const getInitials = (name: string) => {
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    const initials = getInitials(props.name);

    // Inline style for avatar with custom color
    const avatarStyle = props.avatarColor ? {
        backgroundColor: props.avatarColor,
    } : {};

    return (
        <div className="testimonial-box me-2 ms-2">
            <div className="testimonial-text">
                <p>{props.testimonial}</p>
            </div>
            <div className="review-by">
                <div className="review-by-img" aria-hidden="true" style={avatarStyle}>
                    <span className="review-by-initial">{initials}</span>
                    <span className="quote-badge" aria-label="Quote">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" fill="white" />
                            <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" fill="white" />
                        </svg>
                    </span>
                </div>
                <div className="review-by-text">
                    <h3 className="h3-title">{props.name}</h3>
                    {props.location && <p className="review-location">{props.location}</p>}
                    {props.rating && (
                        <div className="rating" aria-label={`Rated ${props.rating} out of 5`}>
                            {Array.from({ length: props.rating }, (_, i) => (
                                <StarIcon key={i} />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TestimonialCard;